import { render, staticRenderFns } from "./Infrastructure.vue?vue&type=template&id=48ccebfb&"
import script from "./Infrastructure.vue?vue&type=script&lang=js&"
export * from "./Infrastructure.vue?vue&type=script&lang=js&"
import style0 from "./Infrastructure.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports